import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { Lock } from "react-feather";

const ConfirmPasswordField = ({
  touched,
  errors,
  values,
  handleChange,
  handleBlur,
}) => {
  return (
    <TextField
      type="password"
      name="confirmPassword"
      variant="outlined"
      label="Confirm Password"
      size="small"
      fullWidth
      value={values.confirmPassword}
      onChange={handleChange}
      onBlur={handleBlur}
      error={Boolean(touched.confirmPassword && errors.confirmPassword)}
      helperText={touched.confirmPassword && errors.confirmPassword}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Lock style={{ height: 14, width: 14, color: "darkgrey" }} />
          </InputAdornment>
        ),
        autoComplete: "new-password",
        form: {
          autoComplete: "off",
        },
      }}
    />
  );
};

export default ConfirmPasswordField;
